import React, { Fragment } from "react"

import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { Button, CircularProgress } from "@mui/material"
import { Tooltip, Typography } from "@synapse-analytics/synapse-ui"

import type { RootState } from "../../store/ReduxStore"

import styles from "./UploadFileBlock.module.scss"

type UploadFileBlockProps = {
  isUploading?: boolean
  fileName?: string
  handleCancel: () => void
  onDelete: () => void
  isReadMode?: boolean
  isDisabled?: boolean
  fileID?: string
}

export function UploadFileBlock(props: Readonly<UploadFileBlockProps>): React.ReactElement {
  const { isDisabled, isReadMode = true, handleCancel, onDelete, isUploading, fileName, fileID } = props
  const currentProject = useSelector((state: RootState) => state.project.currentProject)
  const { t } = useTranslation("common")
  return (
    <div className={styles.cardFieldUpload}>
      {isUploading ? (
        <Fragment>
          <div className={styles.uploadFileProgress}>
            <CircularProgress size={15} style={{ marginRight: "6px" }} color="info" />{" "}
            <Typography variant="a">{t("uploading")}</Typography>
          </div>
          <Button onClick={handleCancel} className={styles.ghostButton} size="small">
            {t("cancelBtn")}
          </Button>
        </Fragment>
      ) : (
        <div className={styles.fileNameContainer}>
          <Tooltip width="100%" title={fileName} placement="top">
            <Link
              to={`/projects/${currentProject?.uuid}/data-files?page=Data-files&file_id=${fileID}`}
              className={styles.link}
            >
              <Typography variant="a" className={styles.name} noWrap color="important" variantColor={2}>
                {props.fileName}
              </Typography>
            </Link>
          </Tooltip>

          {!isReadMode && (
            <Button disabled={isDisabled} onClick={onDelete} className={styles.ghostButton} size="small">
              {t("uplaodFileBlock.removeBtn")}
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
